import {registermainUrls, registermain} from './registermain'

export const registerUrls = [
  ...registermainUrls
]

export const register = {
  registermain
}



// WEBPACK FOOTER //
// ./src/api/gip/register/index.js